import { combineReducers } from 'redux';
import {
  fetchFormAction,
  fetchFormSuccessAction,
  updateDataAction,
} from '../actions/form';
import { createReducer } from 'redux-create-reducer';
import dotProp from 'dot-prop-immutable';

const isFetching = createReducer(false, {
  [fetchFormAction]: (state, action) => {
    return true;
  },
  [fetchFormSuccessAction]: (state, action) => {
    return false;
  },
});

const form = createReducer(
  {},
  {
    [fetchFormSuccessAction]: (state, action) => {
      const infos = action.payload.infos.reduce((map, obj) => {
        map[obj.site_id] = obj;
        return map;
      }, {});
      return {
        ...state,
        infos,
      };
    },
    [updateDataAction]: (state, action) => {
      const { siteId, propName, propValue } = action.payload;
      const stateWithProp = dotProp.set(
        state,
        `infos.${siteId}.${propName}`,
        propValue
      );
      return dotProp.merge(stateWithProp, `infos.${siteId}`, {
        activated: true,
      });
    },
  }
);

const formReducer = combineReducers({
  isFetching,
  form,
});

export default formReducer;

export const getSiteInfos = state => siteId => {
  if (state.form.form && state.form.form.infos) {
    return state.form.form.infos[siteId] || {};
  } else {
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step3/reducers/form.js